export default __webpack_public_path__ + "static/media/IconDesc_HogPart.256.95c37ae1.png";